import React from 'react';
import {
  Breadcrumbs,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Theme,
  Typography,
  Link,
  Box,
  Container,
  CircularProgress,
} from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { lightGreen } from '@material-ui/core/colors';
import { ArrowRightIcon } from '@material-ui/pickers/_shared/icons/ArrowRightIcon';
import { useHistory, useParams } from 'react-router-dom';
import { MenuHeaderTemplate } from '../../../components/templates/MenuHeaderTemplate';
import { PathParams } from '../../../App';
import { CouponPackQuery } from '../../../graphql/generated';
import { useCouponPackDetail } from './hooks/coupon-pack-detail';
import { formatJstDateTimeSecondJapanese } from '../../../util';

const useStyles = makeStyles((theme: Theme) => ({
  infoArea: {
    borderColor: theme.palette.primary.light,
    backgroundColor: lightGreen['50'],
  },
}));

export type CouponPackDetailProps = {
  loading: boolean;
  data?: CouponPackQuery;
};

export const CouponPackDetail: React.FC<CouponPackDetailProps> = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const { couponPackMasterId } = useParams<{ couponPackMasterId: string }>();

  if (props.loading || !props.data) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  const couponPack = props.data?.couponPack.couponPack;
  const couponPackMaster = props.data?.couponPack.couponPackMaster;

  const data = [
    { label: '回数券マスタID', value: couponPackMasterId },
    { label: '回数券ID', value: couponPack.serialNo },
    { label: '回数券名', value: couponPackMaster?.couponName || '-' },
    { label: '回数券コード', value: couponPackMaster?.couponCode || '-' },
    { label: '回数券 URL', value: couponPack?.couponPackUrl || '-' },
    {
      label: '発行日時',
      value: formatJstDateTimeSecondJapanese(props.data?.couponPack?.couponPack?.createdDateTime as string) || '-',
    },
  ];

  return (
    <>
      <Box mb={3}>
        <Breadcrumbs>
          <Link href="#" onClick={() => history.push('/coupon-pack-masters')}>
            回数券マスター覧
          </Link>
          <Link
            component={RouterLink}
            to={{
              pathname: `/coupon-pack-masters/${couponPackMasterId}`,
              search: history.location.search,
              hash: 'overview',
            }}
          >
            回数券マスタ詳細
          </Link>
          <Link
            component={RouterLink}
            to={{
              pathname: `/coupon-pack-masters/${couponPackMasterId}`,
              search: history.location.search,
              hash: 'issued-list',
            }}
          >
            発行済み回数券一覧
          </Link>
          <Typography variant="body1" color="textPrimary">
            回数券詳細
          </Typography>
        </Breadcrumbs>
      </Box>

      <Grid container>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Paper variant="outlined" square className={classes.infoArea}>
              <List dense>
                {data.map((row, index) => (
                  <ListItem key={index}>
                    <ListItemAvatar>
                      <ArrowRightIcon />
                    </ListItemAvatar>
                    <ListItemText primary={row.label} secondary={row.value} />
                  </ListItem>
                ))}
              </List>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export const CouponPackDetailPage: React.FC = () => {
  const { couponPackId } = useParams<PathParams>();
  const couponPackDetail = useCouponPackDetail(couponPackId);
  return (
    <MenuHeaderTemplate header={{ title: '回数券詳細' }}>
      <Container maxWidth="xl">
        <Box>
          <CouponPackDetail {...couponPackDetail} />
        </Box>
      </Container>
    </MenuHeaderTemplate>
  );
};
